async function prepareDevEnvironment() {
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  if (!isLocalhost || !("serviceWorker" in navigator)) {
    return true;
  }

  const reloadKey = `cfpd-sw-cleanup:${window.location.origin}`;
  const registrations = await navigator.serviceWorker.getRegistrations();
  const sameOriginRegistrations = registrations.filter((registration) => {
    try {
      return new URL(registration.scope).origin === window.location.origin;
    } catch {
      return false;
    }
  });

  if (sameOriginRegistrations.length === 0) {
    sessionStorage.removeItem(reloadKey);
    return true;
  }

  await Promise.all(sameOriginRegistrations.map((registration) => registration.unregister()));

  if ("caches" in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
  }

  if (!sessionStorage.getItem(reloadKey)) {
    sessionStorage.setItem(reloadKey, "1");
    window.location.reload();
    return false;
  }

  sessionStorage.removeItem(reloadKey);
  return true;
}

prepareDevEnvironment()
  .then((shouldLoadApp) => {
    if (shouldLoadApp) {
      return import("./main");
    }

    return undefined;
  })
  .catch(() => import("./main"));
